import dayjs from "dayjs";

export const isArraysEqual = (arr1 = [], arr2 = []) => {
  if (arr1.length !== arr2.length) return false;
  return arr1.every((element, index) => element === arr2[index]);
};

export function drawChartJsImage(chart) {
  const ctx = chart.ctx;
  const datasets = chart.data.datasets;

  if (!datasets || datasets.length === 0) return;

  // Find max value and corresponding dataset index & data index
  let maxValue = -Infinity;
  let highestDatasetIndex = 0;
  let highestDataIndex = 0;

  datasets.forEach((dataset, datasetIndex) => {
    dataset.data.forEach((item, dataIndex) => {
      if (item.y > maxValue) {
        maxValue = item.y;
        highestDatasetIndex = datasetIndex;
        highestDataIndex = dataIndex;
      }
    });
  });

  const meta = chart.getDatasetMeta(highestDatasetIndex);
  const bar = meta.data[highestDataIndex];

  if (bar) {
    const image = new Image();
    image.src = "/images/like.png";
    image.onload = () => {
      ctx.drawImage(image, bar.x - 10, bar.y - 30, 20, 20);
    };
  }
}

export function dateFormatForCanvasJS(dateFormat) {
  return dateFormat.includes("a") ? dateFormat.replace("a", "tt") : dateFormat;
}

export const formatDateRangeForMonth = (date) => {
  const startOfMonth = date.startOf("month");
  const endOfMonth = date.endOf("month");
  const formattedStartDate = startOfMonth.format("Do");
  const formattedEndDate = endOfMonth.format("Do MMMM YYYY");
  return `${formattedStartDate} – ${formattedEndDate}`;
};

export const isEditorEmpty = (value = "") => {
  const stripped = value
    .replace(/<p><br><\/p>/gi, "") // remove <p><br></p>
    .replace(/<(.|\n)*?>/g, "") // remove all HTML tags
    .trim();

  return stripped.length === 0;
};

export const cleanObject = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .map(cleanObject)
      .filter(
        (item) =>
          item !== undefined &&
          item !== null &&
          item !== "" &&
          !(Array.isArray(item) && item.length === 0) &&
          !(typeof item === "object" && Object.keys(item).length === 0),
      );
  }

  if (typeof obj === "object" && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleanedValue = cleanObject(value);

      if (
        cleanedValue !== undefined &&
        cleanedValue !== null &&
        cleanedValue !== "" &&
        !(Array.isArray(cleanedValue) && cleanedValue.length === 0) &&
        !(typeof cleanedValue === "object" && Object.keys(cleanedValue).length === 0)
      ) {
        acc[key] = cleanedValue;
      }

      return acc;
    }, {});
  }

  return obj;
};

export const getDashboardFilterDate = ({ xAxis, lastXDaysValue, lastXDays, timeRange, comparisonPeriods = [], window }) => {
  let startDate, endDate;
  if (Array.isArray(comparisonPeriods) && comparisonPeriods.length > 0 && window) {
    const comparisonData = [];
    const validComparisonPeriods = (comparisonPeriods || []).filter((item) => item?.date);
    validComparisonPeriods.forEach((item) => {
      let startDate = dayjs(item.date)?.toISOString();
      let endDate = dayjs(item.date).add(1, window)?.toISOString();
      comparisonData.push({ startDate, endDate, color: item.color });
    });
    return {
      date_gte: comparisonData?.[0]?.startDate,
      date_lte: comparisonData?.[comparisonData?.length - 1]?.endDate,
      comparisonPeriods: JSON.stringify(comparisonData),
    };
  }

  // custom
  if (xAxis === "custom") {
    if (lastXDaysValue && lastXDays) {
      startDate = dayjs().subtract(lastXDaysValue, "days").startOf("day").toISOString();
      endDate = dayjs().endOf("day").toISOString();
    } else if (timeRange && timeRange.length === 2) {
      startDate = dayjs(timeRange[0]).toISOString();
      endDate = dayjs(timeRange[1]).toISOString();
    }
  }

  // daily, weekly, monthly, yearly
  if (["day", "week", "month", "year"].includes(xAxis)) {
    startDate = dayjs().subtract(1, xAxis).startOf("day").toISOString();
    endDate = dayjs().endOf("day").toISOString();
  }

  return { date_gte: startDate, date_lte: endDate };
};


export const chartJsBorderDashMap = {
  dot: [1, 2],
  dash: [5, 5],
  solid: [],
};

export const chartJsMarkerStyleMap = {
  square: "rect",
  triangle: "triangle",
  cross: "cross",
  none: false,
  circle: "circle",
};